import specialLeave from "./SpecialLeave";

export default specialLeave;